import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const LogoBadge = styled.div`
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  border-radius: 100px;
  background-color: var(--background-soft);
`;

export const SecondaryText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${typographyV2.bodyXs};
`;

export const TrackingStatus = styled.span<{ $isTracking: boolean }>`
  color: ${({ $isTracking }) =>
    $isTracking ? 'var(--viz-bullish)' : 'var(--text-soft)'};
`;

export const Horizon = styled.span`
  color: var(--text-soft);
`;

export const AssetNameText = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-default);
`;

export const SecondaryAssetInfoText = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;
